import React, { useState, useEffect } from 'react';
import { reactionsService } from '../../services/firestoreService';
import './EmojiReactions.css';

const EmojiReactions = ({ sessionId, studentId }) => {
  const [reactions, setReactions] = useState([]);
  const [studentReaction, setStudentReaction] = useState(null);
  const [loading, setLoading] = useState(false);

  const emojiOptions = ['👍', '👏', '❤️', '🎉', '😂', '🤔', '🔥', '💡'];

  useEffect(() => {
    // Subscribe to reactions
    const unsubscribe = reactionsService.subscribeToReactions(sessionId, (reactionsList) => {
      setReactions(reactionsList);
    });

    // Get student's current reaction
    reactionsService.getStudentReaction(sessionId, studentId).then(setStudentReaction);

    return () => unsubscribe();
  }, [sessionId, studentId]);

  const handleReaction = async (emoji) => {
    setLoading(true);
    try {
      const wasAdded = await reactionsService.addReaction(sessionId, studentId, emoji);
      setStudentReaction(wasAdded ? emoji : null);
    } catch (error) {
      console.error('Error adding reaction:', error);
      alert('Error adding reaction. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="emoji-reactions-container">
      <h3>💬 How are you feeling?</h3>
      <div className="reactions-display">
        {reactions.map((reaction) => (
          <button
            key={reaction.emoji}
            className={`reaction-btn ${studentReaction === reaction.emoji ? 'active' : ''}`}
            onClick={() => handleReaction(reaction.emoji)}
            disabled={loading}
          >
            <span className="emoji">{reaction.emoji}</span>
            <span className="count">{reaction.count}</span>
          </button>
        ))}
      </div>
      <div className="emoji-options">
        {emojiOptions.map((emoji) => (
          <button
            key={emoji}
            className={`emoji-option ${studentReaction === emoji ? 'selected' : ''}`}
            onClick={() => handleReaction(emoji)}
            disabled={loading}
            title="Click to react"
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmojiReactions;

